import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/(account)/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/exclude-conversations" });
  },
});
